export * from './borderer-window-resize-strategy.component';
